import React, { useState, useEffect, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import Modal from "common/Modal";
import styled from "styled-components";
import NumberInput from "common/NumberInputWithSpinnerState";
import Loading from "common/Loading";

const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 30px;
`;

const ConfirmationWrapper = styled.div`
  margin-top: 25px;
  h4 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    i {
      font-size: 22px;
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }
`;

const ErrorMessage = styled.span`
  text-align: left;
`;

const InputsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const InputWrapper = styled.div`
  width: 40%;
  margin-right: 20px;
`;

const TimeSelector = ({ time, setTime }) => {
  const [hours, minutes, seconds] = time.split(":");
  return (
    <InputsWrapper>
      <InputWrapper>
        <NumberInput
          name="hour"
          label="Hour"
          min={0}
          max={23}
          step={1}
          initialValue={hours}
          onChange={(value) => setTime({ hours: value, minutes, seconds })}
          hideReset={true}
        />
      </InputWrapper>
      <InputWrapper>
        <NumberInput
          name="minute"
          label="Minute"
          min={0}
          max={59}
          step={1}
          initialValue={minutes}
          onChange={(value) => setTime({ hours, minutes: value, seconds })}
          hideReset={true}
        />
      </InputWrapper>
    </InputsWrapper>
  );
};

const TimeModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [bqn, setBqn] = useState("");
  const [timeSelected, setTimeSelected] = useState("");
  const [errorFooter, setErrorFooter] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  useEffect(
    () =>
      actions.recv("set-time", (value) => {
        const { date, time, bqn } = value;
        setDate(date);
        setTime(time);
        setBqn(bqn);
        doOpen();
      }),
    []
  );
  const doOpen = () => {
    setShowConfirm(false);
    setErrorFooter("");
    setTimeSelected("");
    setLoading(false);
    setOpen(true);
  };
  const doClose = () => setOpen(false);

  const doApply = () => {
    if (!showConfirm) {
      setShowConfirm(true);
    } else {
        setLoading(true);
      ifCl
        .run(
          `system date local ${date} ${timeSelected} bqn-id ${
            mode === "cluster" ? bqn : bqnId
          }`
        )
        .then((response) => {
            setLoading(false);
          const indexError = response.indexOf("%ERR");
          if (indexError !== -1) {
            const error = response.slice(indexError, response.length);
            throw Error(error);
          } else {
            doClose();
          }
        })
        .catch((error) => {
            setLoading(false);
            setErrorFooter(`Error: ${error}`);
        });
    }
  };

  const handleTime = (value) => {
    const { hours, minutes } = value;
    setTimeSelected(`${hours}:${minutes}:00`);
  };

  if (!open) return null;
  return (
    <Modal
      title={`Set Time${bqn ? ` for BQN ${bqn}` : ""}`}
      superIcon="edit"
      onApply={doApply}
      closeLabel={!errorFooter ? "CANCEL" : loading ? null : "CLOSE"}
      onClose={doClose}
      applyLabel={!errorFooter && !loading && timeSelected ? "APPLY" : null}
      content={() => {
        return (
          <>
            <TimeSelector time={time} setTime={handleTime} />
            {showConfirm && !errorFooter && !loading ? (
              <ConfirmationWrapper>
                <h4>
                  <i className="material-icons">info</i> Confirm time change?
                </h4>
                <div>
                  Changing the time by more than a few minutes may cause
                  a disruption in traffic
                  of 10 seconds to 2 minutes, depending on the number of
                  interfaces, CPU cores, and memory size.
                  In any case, after a time change, it is
                  recommended to perform a software reload of the active bqn
                  package in Administration &gt; Software.
                </div>
              </ConfirmationWrapper>
            ) : null}
            {loading ?<LoadingWrapper><Loading /></LoadingWrapper>:null}
          </>
        );
      }}
      footerMessage={
        errorFooter !== "" ? (
          <ErrorMessage className="color-red">
            <h5>{errorFooter}</h5>
          </ErrorMessage>
        ) : null
      }
    />
  );
};

export default TimeModal;
